let initialState = {}

export const profileReducer = (state: any = initialState, action: any): any => {
    switch(action.type) {
        default:
            return state
    }
}